import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { USER_PLAN_SERVICE_METHOD } from "services/commonService";
import { DISPLAY_TYPE } from "utils/CommonConstants";
import { fetchSuggestedPlansIdAsync } from "../library/SuggestedPlans/SuggestedPlans.slice";

const SLICE = "Dashboard";

const configTabSelectedInitialState = {
  [DISPLAY_TYPE.bookmarkedPropertiesPlans]: 0
};
const initialState: any = {
  dashboardMetrics: {},
  shouldShowEmailDialog: false,
  shouldShowManageEstateRoleDiaog: false,
  savedFiltersAndLists: {},
  isFilterApiCalled: false,
  bookMarkInncodes: [],
  configTabSelected: configTabSelectedInitialState
};

export const fetchBookmarkedInncodeAsync = createAsyncThunk(
  `${SLICE}/fetchBookmarkedInncodeAsync`,
  (data: {}, thunkApi) => apiRequest(USER_PLAN_SERVICE_METHOD.getBookmarkedInncodeAsync, {}, thunkApi)
);

export const updateBookmarkedInncodesAsync = createAsyncThunk(
  `${SLICE}/updateBookmarkedInncodesAsync`,
  (data: any, thunkApi) => apiRequest(USER_PLAN_SERVICE_METHOD.putBookmarked, data, thunkApi)
);

export const DashboardSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    clearDashboardData: (state) => {
      state.shouldShowEmailDialog = initialState.shouldShowEmailDialog;
    },
    setOpenEmailDialog: (state, action) => {
      state.shouldShowEmailDialog = action.payload;
    },
    setOpenManageEstateRoleDialog: (state, action) => {
      state.shouldShowManageEstateRoleDiaog = action.payload;
    },
    setBookmarkedInncodes: (state, action) => {
      state.bookMarkInncodes = action.payload;
    },
    setConfigTabSelected: (state, action) => {
      state.configTabSelected[action.payload.type] = action.payload.val;
    },
    resetConfigTabSelected: (state, action) => {
      state.configTabSelected = configTabSelectedInitialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuggestedPlansIdAsync.fulfilled, (state, action: any) => {
        state.dashboardMetrics = action.payload.metrics;
      })
      .addCase(fetchBookmarkedInncodeAsync.fulfilled, (state, action: any) => {
        state.bookMarkInncodes = action.payload?.bookmarks || [];
      })
      .addCase(updateBookmarkedInncodesAsync.fulfilled, (state, action: any) => {
        if (action.meta.arg.shouldUpdateState !== false) state.bookMarkInncodes = action.payload.bookmarks;
      });
  }
});

export const {
  clearDashboardData,
  setOpenEmailDialog,
  setBookmarkedInncodes,
  setConfigTabSelected,
  resetConfigTabSelected,
  setOpenManageEstateRoleDialog
} = DashboardSlice.actions;
export default DashboardSlice.reducer;
